import { useEffect, useState } from 'react';
import { getPdfSource } from 'src/utils/file';
import PdfViewer from './PdfViewer';
import PdfLoader from './PdfLoader';
import PdfFallback from './PdfFallback';

interface PdfViewerContainerProps {
  fileUrl?: string;
  fileExtension?: string;
  submissionContextId?: string;
  organizationId?: string;
  viewerHeight?: string;
}

export function PdfViewerContainer({
  fileUrl,
  fileExtension,
  submissionContextId,
  organizationId,
  viewerHeight
}: PdfViewerContainerProps) {
  const [pdfUrl, setPdfUrl] = useState<string>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    setPdfUrl(undefined);
    setError(undefined);

    if (!fileUrl || !fileExtension) {
      return;
    }

    if (fileExtension !== 'pdf') {
      setError('File format not supported. Only PDF files can be viewed.');
      return;
    }

    getPdfSource(fileUrl, { submissionContextId, organizationId })
      .then(setPdfUrl)
      .catch(() => {
        setError('Unable to load PDF.');
      });
  }, [fileUrl, fileExtension, organizationId, submissionContextId]);

  if (error || !fileUrl) {
    return <PdfFallback />;
  }

  if (fileUrl && !pdfUrl) {
    return <PdfLoader viewerHeight={viewerHeight} />;
  }

  return <PdfViewer file={pdfUrl!} viewerHeight={viewerHeight} />;
}
